<template>
    <span v-if="user.id > 0">
        <span v-if="name.prefix">{{ name.prefix }}</span>
        <user-link :id="user.id" :name="user.name" />
        <span v-if="name.suffix">{{ name.suffix }}</span>
    </span>
    <span v-else>{{ user.name }}</span>
</template>

<script>
import UserLink from '@/components/UserLink.vue';

export default {
    props: {
        user: Object,
    },
    computed: {
        name() {
            const [ prefix, suffix ] = this.user.template.split(this.user.id, 2);
            return { prefix, suffix };
        }
    },
    components: {
        UserLink,
    }
}
</script>

<style>

</style>